import React, { useState, useEffect, useCallback } from 'react';
import { Table, Drawer, Message } from '@b-design/fusion';
import Button from '@/components/Button';
import PaginationComponent from '@/components/PaginationComponent';
import Confirm from '@/components/Confirm';
import $i18n from '@/i18n';
import './index.less';
import { Divider } from '@alifd/next';
import { spacesColumns, renderActionItem } from './const.js';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import NameIcon from '@/components/NameIcon';

interface Spaces {
  contentHeight: number;
}

const Spaces: React.FC<Spaces> = ({ contentHeight }) => {
  const [column, setColumns] = useState<any[]>(spacesColumns);
  const [dataSource, setDataSource] = useState({ list: [], total: 0 });
  const { spaceId } = getQueryStringArgs();
  const [visible, setVisible] = useState(false);
  const [detail, setDetail] = useState({});
  const [companyDate, setCompanyDate] = useState({});
  const arrStatus = ['CREATED', 'REJECT', 'WITHDRAW'];
  const [loading, setLoading] = useState(false);
  // filter
  const [filterValue, setFilterValue] = useState<{
    status?: string | undefined;
  }>();
  const renderPhone = (v) => {
    if (v) {
      let text = '';
      if (v !== '-') {
        if (v?.split('-')[0]) {
          text = `+${v?.split('-')[0]} ${v?.split('-')[1]}`;
        } else {
          text = `${v?.split('-')[1]}`;
        }
      } else {
        text = '';
      }
      return text;
    }
  };

  // const showDrawer=useCallback(
  //   (record)=>{
  //     setVisible(true);
  //     setDetail(record);

  //     if (record.companyId) {
  //       // 获取公司信息
  //       Requests.get('/rest/intercnn/company/query', {
  //         companyIds: record?.companyId,
  //       }).then((data) => {
  //         if (data) {
  //           setCompanyDate(data.list);
  //         }
  //       });
  //     }
  //   },[]
  // )

  const showDrawer = (record) => {
    setVisible(true);
    setDetail(record);

    if (record.companyId) {
      // 获取公司信息
      Requests.get('/rest/intercnn/company/query', {
        companyIds: record?.companyId,
      }).then((data) => {
        if (data) {
          setCompanyDate(data.list);
        }
      });
    } else {
      setCompanyDate({});
    }
  };
  // 状态改变
  //  const getStatus=useCallback((record)=>{
  //   if(record?.status === 'ACTIVE'){
  //     return <Confirm
  //     trigger={renderActionItem({
  //       icon: 'settings--outline',
  //       i18nId: 'aopf.pages.invitations.columnsActionForbidden',
  //       dm: '禁止',
  //       abled:true
  //     })}
  //     dialogTitle={$i18n.get({
  //       id: 'aopf.pages.invitation.columnsActionForbidden.message',
  //       dm: '你确定要阻止吗?',
  //     })}
  //     width={300}
  //     onClick={()=>forbidden(record)}
  //   />
  //   }else if(record?.status === 'BLOCKED'){
  //     <Confirm
  //     trigger={renderActionItem({
  //       icon: 'settings--outline',
  //       i18nId: 'aopf.pages.invitations.columnsAction',
  //       dm: '恢复',
  //       abled:true
  //     })}
  //     dialogTitle={$i18n.get({
  //       id: 'aopf.pages.invitation.columnsActionForbidden.message',
  //       dm: '你确定要阻止吗?',
  //     })}
  //     width={300}
  //     onClick={()=>forbidden(record)}
  //   />
  //   }else{
  //     renderActionItem({
  //       icon: 'subtract--circle--outline',
  //             i18nId: 'aopf.pages.invitations.columnsActionForbidden',
  //             dm: '禁止',
  //             abled: false
  //           })
  //         }
  //       },[])

  const onClose = () => {
    setVisible(false);
  };

  // 分页参数
  const [paginationValue, setPaginationValue] = useState<
    Record<'currentPage' | 'pageSize', number>
  >({
    currentPage: 1,
    pageSize: 10,
  });

  // 获取三房成员列表

  const querySpaces = useCallback(
    (params = { belongSpaceId: spaceId, currentPage: 1, pageSize: 10 }) => {
      if (!spaceId) {
        return;
      };
      setLoading(true);
      Requests.get('/rest/intercnn/space/query', { ...params }).then((data) => {
        if (data) {
          const { list = [], total } = data;
          const newList = list?.map((item) => ({
            ...item,
            roleList: item?.role?.split(',') || [],
          }));
          setDataSource({ list: newList, total });
          setLoading(false);
        }
      });
    },
    [spaceId],
  );

  useEffect(() => {
    querySpaces({ belongSpaceId: spaceId, ...paginationValue, ...filterValue });
  }, [paginationValue, querySpaces, spaceId, filterValue]);
  // 禁止
  const forbidden = useCallback(
    async (record) => {
      const data = await Requests.post('/rest/intercnn/space/forbidden', {
        spaceId: record.spaceId,
      });
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.invitation.spaces.message.Success',
            dm: '操作成功',
          }),
        });
        querySpaces({ belongSpaceId: spaceId, ...paginationValue, ...filterValue });
      }
    },
    [querySpaces, paginationValue, filterValue],
  );
  // 删除
  const deleteSpace = useCallback(
    async (record) => {
      const data = await Requests.post('/rest/intercnn/space/delete', {
        spaceId: record.spaceId,
      });
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.invitation.spaces.message.deleteSuccess',
            dm: '删除成功',
          }),
        });
        querySpaces({ belongSpaceId: spaceId, ...paginationValue, ...filterValue });
      }
    },
    [querySpaces, paginationValue, filterValue],
  );
  // 恢复
  const recoverSpace = useCallback(
    async (record) => {
      const data = await Requests.post('/rest/intercnn/space/enable', {
        spaceId: record.spaceId,
      });
      if (data) {
        Message.success({
          title: $i18n.get({
            id: 'aopf.pages.invitation.spaces.message.Success',
            dm: '操作成功',
          }),
        });
        querySpaces({ belongSpaceId: spaceId, ...paginationValue, ...filterValue });
      }
    },
    [querySpaces, paginationValue, filterValue],
  );
  useEffect(() => {
    const getStatus = (record) => {
      if (record?.status === 'ACTIVE') {
        return (
          <Confirm
            trigger={renderActionItem({
              icon: 'settings--outline',
              content: $i18n.get({
                id: 'aopf.pages.invitations.columnsActionForbidden',
                dm: '禁止',
              }),
              // i18nId: 'aopf.pages.invitations.columnsActionForbidden',
              // dm: '禁止',
              active: true,
            })}
            dialogTitle={$i18n.get({
              id: 'aopf.pages.invitation.columnsActionForbidden.messageTitle',
              dm: '禁用三方空间',
            })}
            dialogContent={$i18n.get({
              id: 'aopf.pages.invitation.columnsActionForbidden.message',
              dm: '你确定要禁用该空间吗?',
            })}
            width={500}
            onClick={forbidden.bind(null, record)}
          />
        );
      } else if (record?.status === 'BLOCKED') {
        return (
          <Button type="normal" text onClick={recoverSpace.bind(null, record)}>
            {renderActionItem({
              icon: 'animation--3d--mode--outline',
              content: $i18n.get({
                id: 'aopf.pages.invitations.columnsActionRecover',
                dm: '恢复',
              }),
              // i18nId: 'aopf.pages.invitations.columnsActionRecover',
              // dm: '恢复',
              active: true,
            })}
          </Button>
        );
      } else {
        return renderActionItem({
          icon: 'subtract--circle--outline',
          content: $i18n.get({
            id: 'aopf.pages.invitations.columnsActionForbidden',
            dm: '禁止',
          }),
          // i18nId: 'aopf.pages.invitations.columnsActionForbidden',
          // dm: '禁止',
          active: false,
        });
      }
    };
    const actionRender = {
      title: $i18n.get({ id: 'aopf.pages.member.columnsAction', dm: '操作' }),
      dataIndex: 'action',
      width: 320,
      // lock: true,
      cell: (value, index, record) => (
        <div
          style={{
            color: 'var(--superapp-primary-1)',
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
          }}
        >
          <div onClick={() => showDrawer(record)}>
            {renderActionItem({
              icon: 'view--outline',
              content: $i18n.get({
                id: 'aopf.pages.invitations.columnsActionView',
                dm: '查看细节',
              }),
              // i18nId: 'aopf.pages.invitations.columnsActionView',
              // dm: '查看细节',
              active: true,
            })}
          </div>
          <Divider direction="ver" />
          {/* <div
           onClick={()=>forbidden(record)}
          >
          {renderActionItem({
           icon: 'subtract--circle--outline',
           i18nId: 'aopf.pages.invitations.columnsActionForbidden',
           dm: '禁止',
           abled:record?.status=='ACTIVE'
          })}
          </div>
          <Divider direction="ver" /> */}

          {/* {record?.status === 'ACTIVE' ? <Confirm
           trigger={renderActionItem({
             icon: 'settings--outline',
             i18nId: 'aopf.pages.invitations.columnsActionForbidden',
             dm: '禁止',
             abled:true
           })}
           dialogTitle={$i18n.get({
             id: 'aopf.pages.invitation.columnsActionForbidden.message',
             dm: '你确定要阻止吗?',
           })}
           width={300}
           onClick={()=>forbidden(record)}
          />:renderActionItem({
           icon: 'subtract--circle--outline',
           i18nId: 'aopf.pages.invitations.columnsActionForbidden',
           dm: '禁止',
           abled: false
          }) } */}
          {getStatus(record)}
          <Divider direction="ver" />

          {arrStatus.includes(record?.status) ? (
            <Confirm
              trigger={renderActionItem({
                icon: 'trash-can--outline',
                content: $i18n.get({
                  id: 'aopf.pages.invitation.actionDeleteTitle',
                  dm: '删除',
                }),
                // i18nId: 'aopf.pages.invitation.actionDeleteTitle',
                // dm: '删除',
                active: arrStatus.includes(record?.status),
              })}
              dialogTitle={$i18n.get({
                id: 'aopf.pages.invitation.actionDeleteTitle',
                dm: '删除',
              })}
              dialogContent={$i18n.get({
                id: 'aopf.pages.invitation.actionDeletePop',
                dm: '确定删除此成员?',
              })}
              onClick={deleteSpace.bind(null, record)}
              width={500}
            />
          ) : (
            renderActionItem({
              icon: 'trash-can--outline',
              content: $i18n.get({
                id: 'aopf.pages.member.columnsActionDelete',
                dm: '删除',
              }),
              // i18nId: 'aopf.pages.member.columnsActionDelete',
              // dm: '删除',
              active: arrStatus.includes(record?.status),
            })
          )}
        </div>
      ),
    };
    setColumns([...spacesColumns, actionRender]);
  }, [paginationValue, spaceId, forbidden, deleteSpace, recoverSpace]);
  return (
    <div>
      <div className="list-content">
        <Table.StickyLock
          fixedHeader
          maxBodyHeight={contentHeight - 48}
          loading={loading}
          columns={column}
          dataSource={dataSource?.list}
          rowkey="spaceId"
          // onFilter={(filterParms) => {
          //   const filter = {};
          //   for (const [key, value] of Object.entries(filterParms)) {
          //     filter[key] = (value as any)?.selectedKeys?.[0];
          //   }

          //   setFilterValue((pre) => ({ ...pre, ...filter }));
          // }}
        />
        <div className="pagenation-container">
          <PaginationComponent
            total={dataSource?.total}
            current={paginationValue?.currentPage}
            pageSize={paginationValue?.pageSize}
            onPageChange={(current, pageSize) => {
              setPaginationValue({
                currentPage: current,
                pageSize,
              });
            }}
          />
        </div>
      </div>
      {/* 设置弹框 */}
      {/* <SetAsModal
         setAsVisible={setAsVisible}
         setSetAsRole={setSetAsRole}
         setAsRole={setAsRole}
         onClose={onClose}
        /> */}
      <Drawer
        data-size="large"
        title={$i18n.get({ id: 'aopf.component.spaces.SpatialInformation', dm: '空间信息' })}
        placement="right"
        onClose={onClose}
        visible={visible}
      >
        <div className="invitation-space-container">
          <div className="invitation-space-content">
            <div className="invitation-space-line">
              <div className="invitation-space-lineLeft">
                <span>*</span>
                {$i18n.get({
                  id: 'aopf.pages.invitation.space.name',
                  dm: '空间名称',
                })}
              </div>
              <div className="invitation-space-lineRight">{detail?.name}</div>
            </div>

            <div className="invitation-space-line">
              <div className="invitation-space-lineLeft">
                <span>&nbsp;&nbsp;</span>
                {$i18n.get({
                  id: 'aopf.pages.invitation.space.icon',
                  dm: '空间图标',
                })}
              </div>
              {detail?.iconPublicUrl ? (
                <img style={{ width: 54, height: 54 }} src={detail?.iconPublicUrl} />
              ) : (
                <NameIcon name={detail?.name} />
              )}
            </div>

            <div className="invitation-space-line">
              <div className="invitation-space-lineLeft">
                <span>*</span>
                {$i18n.get({
                  id: 'aopf.pages.invitation.space.companyName',
                  dm: '公司名字',
                })}
              </div>
              <div className="invitation-space-lineRight">{companyDate[0]?.name}</div>
            </div>

            <div className="invitation-space-line">
              <div className="invitation-space-lineLeft">
                <span>*</span>
                {$i18n.get({
                  id: 'aopf.pages.invitation.space.businessAddress',
                  dm: '公司地址',
                })}
              </div>
              <div className="invitation-space-lineRight">{companyDate[0]?.address}</div>
            </div>

            <div className="invitation-space-line">
              <div className="invitation-space-lineLeft">
                <span>*</span>
                {$i18n.get({
                  id: 'aopf.pages.invitation.space.representative',
                  dm: '公司法人',
                })}
              </div>
              <div className="invitation-space-lineRight">{companyDate[0]?.principal}</div>
            </div>

            <div className="invitation-space-line">
              <div className="invitation-space-lineLeft">
                &nbsp;
                {$i18n.get({
                  id: 'aopf.pages.invitation.space.Website',
                  dm: '网站',
                })}
              </div>
              <div className="invitation-space-lineRight">{companyDate[0]?.webPage}</div>
            </div>

            <div className="invitation-space-line">
              <div className="invitation-space-lineLeft">
                &nbsp;
                {$i18n.get({
                  id: 'aopf.pages.invitation.space.contactNumber',
                  dm: '联系方式',
                })}
              </div>
              <div className="invitation-space-lineRight">
                {renderPhone(companyDate[0]?.customerPhone)}
              </div>
            </div>

            <div className="invitation-space-line">
              <div className="invitation-space-lineLeft">
                &nbsp;
                {$i18n.get({
                  id: 'aopf.pages.invitation.space.emailAddress',
                  dm: '邮箱地址',
                })}
              </div>
              <div className="invitation-space-lineRight">{companyDate[0]?.customerEmail}</div>
            </div>
          </div>
          <div>
            <Button
              type="primary"
              onClick={onClose}
              style={{ marginRight: '8px', height: 40, width: 98, fontSize: '16px' }}
            >
              {$i18n.get({ id: 'aopf.component.spaces.Cancel', dm: '关闭' })}
            </Button>
            {/* <Button onClick={onClose}>取消</Button> */}
          </div>
        </div>
      </Drawer>
    </div>
  );
};
export default Spaces;
